import { Theme, makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: 700,
      maxWidth: 700,
      "& > *:nth-child(2)": {
        alignSelf: "stretch",
      },
    },
    settingsContainer: {
      flex: "1 1 100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    slideSelection: {
      "&:has(.ReportToolbarGroup:empty)": {
        display: "none",
      },
    },
  })
);
